import { exists } from './exists.js';

function getFiles(dataTransfer) {
  if (!dataTransfer.types.includes("Files")) {
    return [];
  }
  let files = Array.from(dataTransfer.items).map((item) => {
    const entry = item.webkitGetAsEntry();
    return entry && entry.isFile ? item.getAsFile() : null;
  }).filter(exists);
  if (!files.length) {
    files = Array.from(dataTransfer.files).filter((file) => file.type !== "");
  }
  return files;
}

export { getFiles };
//# sourceMappingURL=data-transfer.js.map
